<script setup>
import navItems from "@/navigation/vertical";
import { useSettingStore } from "@/views/apps/setting/settingStore";

// Composable
import { useSkins } from "@core/composable/useSkins";
import { useThemeConfig } from "@core/composable/useThemeConfig";

// Components
import Footer from "@/layouts/components/Footer.vue";
import UserProfile from "@/layouts/components/UserProfile.vue";

// @layouts plugin
import { VerticalNavLayout } from "@layouts";
import { watchEffect } from "vue";
import Notification from "./Notification.vue";
import TsButton from '@/components/app/TsButton.vue'
import ImposterDisplay from "@/layouts/components/ImposterDisplay.vue";

const { appRouteTransition, isLessThanOverlayNavBreakpoint } = useThemeConfig();
const { width: windowWidth } = useWindowSize();
const { layoutAttrs, injectSkinClasses } = useSkins();
const currentUserData = ref(JSON.parse(localStorage.getItem("userData")));
const settingStore = useSettingStore();

const getUserData = () => {
  currentUserData.value = JSON.parse(localStorage.getItem("userData"));
};

watchEffect(() => {
  getUserData();
});

const clickAcademyLink = () => window.open('https://tellscale.learningsuite.io/', '_blank');

// ℹ️ This will inject classes in body tag for accurate styling
injectSkinClasses();
</script>

<template>
  <VerticalNavLayout :nav-items="navItems" v-bind="layoutAttrs">
    <!-- 👉 navbar -->
    <template #navbar="{ toggleVerticalOverlayNavActive }">
        <div class="d-flex justify-space-between align-center w-100">
            <div>
                <imposter-display/>
            </div>
            <div class="d-flex h-100 align-center">
                <ts-button
                    icon="mdi:mdi-account-school"
                    class="mr-2"
                    type="plain"
                    @click="clickAcademyLink"
                >TellScale Academy</ts-button>
                <div style="padding-right: 10px"></div>
                <div class="seprator" />
                <Notification />
                <div class="user-name-container">
                    <p class="user-name">
                        {{ currentUserData?.first_name }} {{ currentUserData?.last_name }}
                    </p>
                </div>
                <UserProfile />
            </div>
        </div>
    </template>

    <!-- 👉 Pages -->
    <RouterView v-slot="{ Component }">
      <Transition :name="appRouteTransition" mode="out-in">
        <Component :is="Component" />
      </Transition>
    </RouterView>

    <!-- 👉 Footer -->
    <template #footer>
      <Footer />
    </template>

    <!-- 👉 Customizer -->
    <TheCustomizer />
  </VerticalNavLayout>
</template>
<style>
.student-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.student-text {
  margin-left: 10px;
  color: #c6c8cf;
  margin-bottom: 0px;
}

.search-bar {
  margin-left: 3.188rem;
  background-color: white;
  width: 13.5rem;
  height: 2.375rem;
  box-shadow: 0px 10px 60px rgba(226, 236, 249, 0.5);
  border-radius: 12px;
  display: flex;
  /* justify-content: center; */
  align-items: center;
  padding: 10px;
}

.serach-text {
  color: #b5b7c0;
  margin-bottom: 0px;
}

.notification-bar {
  margin-left: 21px;
}

.seprator {
  margin-left: 21px;
  border: 1px solid #dfe0eb;
  height: 32px;
}

.user-name {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  text-align: right;
  letter-spacing: 0.2px;
  color: #252733;
  margin-bottom: 0px;
}

.user-name-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
